import { createEventBus } from "ts-event-bus";
import TrailwiseEvents from "./TrailwiseEvents";

const TrailwiseEventBus = createEventBus({
    events: TrailwiseEvents
});

export default TrailwiseEventBus;